import { createFileRoute } from '@tanstack/react-router'
import AdminTesterFeedbackPage from '@/spa/pages/admin/AdminTesterFeedbackPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/admin/tester-feedback')({
  component: AdminTesterFeedbackPage,
  errorComponent: routeErrorComponent,
})
